<template>
  <template v-if="$route.query.disableAnimation">
    <slot></slot>
  </template>
  <transition v-else v-bind="$attrs"><slot v-if="true"></slot></transition>
</template>
